import React from 'react';
import { StyledErrorValidation } from "./ErrorValidation.styles";

export const ErrorValidation: React.FC = (props) => {
    return <StyledErrorValidation {...props}/>
};
